import React from 'react';

import EventsPage from '../../../../components/EventsPage';
import PageLayout from '../../../../components/layouts/PublicPage';
import useDesktop from '../../../../hooks/useDesktop';

const Events = () => {
  const isDesktop = useDesktop();

  return (
    <PageLayout
      noPadding={!isDesktop}
      showBackButton={false}
      hideHeader={isDesktop}
      maxWidth={false}
      minFullHeight={isDesktop}
    >
      <EventsPage publicSection displayByYear />
    </PageLayout>
  );
};

export default Events;
